/**
 * Because we don't want the sorting to start with punctuation marks we remove them from the
 * Location name for example 't Zand en Callantsoog or 's- like 's-Gravenhage.
 *
 * @param city 't Zand en Callantsoog | 's-Gravenhage
 * @returns Zand en Callantsoog | Gravenhage
 */
export const cityNameFromFirstCapital = (city: string): string => {
  const match = city.match(/[A-Z]/);
  return match?.index ? city.substring(match.index, city.length) : city;
};
